import { render, staticRenderFns } from "./ProfilePublicationAgreement.vue?vue&type=template&id=6a6e34d6&"
import script from "./ProfilePublicationAgreement.vue?vue&type=script&lang=js&"
export * from "./ProfilePublicationAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePublicationAgreement.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/ProfilePublicationAgreement.vue
// module id = 1247
// module chunks = 0